import * as React from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
// eslint-disable-next-line no-restricted-imports
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';

const DisclaimersContainer = styled.div`
  text-align: left;
`;

export interface DisclaimersProps {
  disclaimers?: string[];
}

export const Disclaimers: React.FC<DisclaimersProps> = ({ disclaimers }) => {
  const fontSize = process.env.IS_LEGACY ? '2' : '3';

  if (!disclaimers || !disclaimers.length) return null;

  return (
    <DisclaimersContainer data-testid="disclaimers">
      {disclaimers?.map((disclaimer, i) => (
        <Text key={`disclaimer${i}`} variant={{ type: 'copy', order: fontSize, style: 'normal' }}>
          {renderTextWithFootnotesReferencesV2(disclaimer)}
        </Text>
      ))}
    </DisclaimersContainer>
  );
};

Disclaimers.displayName = 'Disclaimers';
